module.exports = __webpack_public_path__ + "fonts/font.0a0d89a5.woff";